
import Component from '../src/components/Publisher/VehicleListingsStandard.vue';

// Register component globally without any prefix if Vue is available.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('vehicle-listings-standard', Component);
}

export default Component;
    